import request from '@/utils/request';
const path = 'promotion/jrtt';

/** 获取广告列表接口 */
export function getPromotionListApi(data) {
  return request({
    url: `/${path}`,
    method: 'get',
    params: data,
  });
}

/**
 * 获取广告详情接口
 * @param {number} source_id 项目资源ID
 */
export function getPromotionInfoApi(source_id) {
  return request({
    url: `/${path}/${source_id}`,
    method: 'get',
  });
}

/** 创建广告接口 */
export function createPromotionApi(data) {
  return request({
    url: `/${path}`,
    method: 'post',
    data,
  });
}

/** 更新广告接口 */
export function updatePromotionApi(source_id, data) {
  return request({
    url: `/${path}/${source_id}`,
    method: 'put',
    data,
  });
}

/** 获取广告列表选择器接口 */
export function getPromotionSelectorApi(data) {
  return request({
    url: `/${path}/selector`,
    method: 'get',
    params: data,
  });
}

/** 同步广告列表接口 */
export function pullPromotionListApi(data) {
  return request({
    url: `/${path}/pull`,
    method: 'get',
    params: data,
  });
}

/**
 * 批量删除广告接口
 * @param {{
 *  source_ids: number[]
 * }} data 参数
 */
export function batchDeletePromotionApi(data) {
  return request({
    url: `/${path}/batchDelete`,
    method: 'post',
    data,
  });
}
